import { Component, OnInit, ViewChild, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { IDestinationCard } from '../../interfaces/ICheckForCardResponse.interface';
import { DirectDebitService } from '../../services/direct-debit.service';

@Component({
    selector: 'app-carousel-direct-debit',
    templateUrl: './carousel-card.component.html',
    styleUrls: ['./carousel-card.component.scss']
})
export class CarouselDirectDebitComponent implements OnInit, OnDestroy {
    @Input() cards: IDestinationCard[];
    @Output() cardSelected = new EventEmitter<IDestinationCard>();
    @Input() CardSelectedRef: IDestinationCard;
    @ViewChild('slickModal')
    slick: SlickCarouselComponent;

    isMobile: boolean;

    slideConfig = {
        infinite: false,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true /*remove width from slick slide*/,
        speed: 1000,
        rtl: true,
        nextArrow: '<div class="slick-prev slick-arrow"></div>',
        prevArrow: '<div class="slick-next slick-arrow"></div>',
        responsive: [
            {
                breakpoint: 520,
                settings: {
                    arrows: false,
                    centerMode: false,
                    cssEase: 'none',
                    variableWidth: true,
                    variableHeight: false,
                    centerPadding: '80px',
                    speed: 200,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    isLoaded = false;

    constructor(
        private uiHelper: UiHelperService,
        private gtmService: GtmService,
        private directDebSrv: DirectDebitService
    ) {}

    selectCard(card: IDestinationCard): void {
        this.CardSelectedRef = card;
        this.cardSelected.emit(card);
    }

    ngOnInit(): void {
        this.isMobile = this.uiHelper.IsMobile(768);
        this.slideConfig.arrows = this.cards.length > 3;
        this.cardSelected.emit(this.CardSelectedRef);
        this.isLoaded = true;
        this.slideConfig.responsive[0].settings.centerMode = this.cards?.length === 1;
    }

    ngOnDestroy(): void {}
}
